import { WeissmanKeyValueDisplayPipe } from '../../../../UI-Lib/Pipes';
import { ExtendedModelBase } from '../../../Models/extendedModelBase';

export class ExtendedGLAccountModel extends ExtendedModelBase<Compliance.GLAccountModel> {
    constructor(model: Compliance.GLAccountModel, keyValueDisplayPipe: WeissmanKeyValueDisplayPipe) {
        super(model);
        this._keyValueDisplayPipe = keyValueDisplayPipe;
        this._displayName = this._keyValueDisplayPipe.transform(this.model, this.model.accountNumber, this.model.accountName);
    }

    private readonly _keyValueDisplayPipe: WeissmanKeyValueDisplayPipe;
    private _displayName: string;

    set displayName(value: string) {
        this._displayName = value;
    }

    get displayName(): string {
        return this._displayName;
    }
}
